export const user = `
uid
bio
displayName
photoURL
updatedAt
`
